import { LABELS, STATUSES } from '@/constants/common/message.constants'

import { type ContractEntity } from '../..'
import { type ToursRequestQuery } from '../tours'

/**
 * 契約種別
 */
export type ContractType = ContractEntity['type']

export const CONTRACT_TYPE = {
  /** 車建 */
  SYA_DATE: 'SYA_DATE',
  /** 運行建 */
  UNKOU_DATE: 'UNKOU_DATE',
  /** 個建 */
  TANKA: 'TANKA',
  /** タリフ */
  TARIFF: 'TARIFF'
} as const satisfies Record<ContractType, ContractType>

/**
 * 画面で選択できる契約種別（個建を除く）。
 *
 * 個建（TANKA）は #5551 で入口を閉じた。enum 自体は BE スキーマに残るため
 * CONTRACT_TYPE から外さず、選択肢・URL 検索条件の受け口だけこの picklist で絞る。
 */
export const CONTRACT_TYPE_SELECTABLE = [
  CONTRACT_TYPE.SYA_DATE,
  CONTRACT_TYPE.UNKOU_DATE,
  CONTRACT_TYPE.TARIFF
] as const satisfies readonly Exclude<ContractType, 'TANKA'>[]

export type ContractTypeSelectable = (typeof CONTRACT_TYPE_SELECTABLE)[number]

export const CONTRACT_TYPE_LABEL = {
  [CONTRACT_TYPE.SYA_DATE]: LABELS.CONTRACT_TYPE_SYA_DATE,
  [CONTRACT_TYPE.UNKOU_DATE]: LABELS.CONTRACT_TYPE_UNKOU_DATE,
  [CONTRACT_TYPE.TANKA]: LABELS.CONTRACT_TYPE_TANKA,
  [CONTRACT_TYPE.TARIFF]: LABELS.CONTRACT_TYPE_TARIFF
} as const satisfies Record<ContractType, string>

/**
 * 契約種別にエラーを追加した型
 */
export type ContractTypeWithError = Exclude<
  NonNullable<ToursRequestQuery>['contractType'],
  undefined
>

export const CONTRACT_TYPE_WITH_ERROR = {
  ...CONTRACT_TYPE,
  /** エラー */
  ERROR: 'ERROR',
  /** キャンセル */
  CANCELED: 'CANCELED'
} as const satisfies Record<ContractTypeWithError, ContractTypeWithError>

/**
 * 画面で選択できる契約種別＋エラー/キャンセル（個建を除く）。CONTRACT_TYPE_SELECTABLE と同趣旨。
 */
export const CONTRACT_TYPE_WITH_ERROR_SELECTABLE = [
  ...CONTRACT_TYPE_SELECTABLE,
  CONTRACT_TYPE_WITH_ERROR.ERROR,
  CONTRACT_TYPE_WITH_ERROR.CANCELED
] as const satisfies readonly Exclude<ContractTypeWithError, 'TANKA'>[]

export const CONTRACT_TYPE_WITH_ERROR_LABEL = {
  ...CONTRACT_TYPE_LABEL,
  [CONTRACT_TYPE_WITH_ERROR.ERROR]: STATUSES.FAILED,
  [CONTRACT_TYPE_WITH_ERROR.CANCELED]: STATUSES.CANCELLED
} as const satisfies Record<ContractTypeWithError, string>
